var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"header"},[_c('Header')],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }